import { render, staticRenderFns } from "./EditProviderModal.vue?vue&type=template&id=26d5a528"
import script from "./EditProviderModal.vue?vue&type=script&lang=js"
export * from "./EditProviderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports